import { useContext } from 'react';
import { Context as PlannerItemContext } from '@context/PlannerItemContext';
import PlannerItemMenu from './PlannerItemMenu';

const PlannerItemMenuWrapper = () => {
  const { closeActionMenu, menuAnchorEl, selectedItemRef } =
    useContext(PlannerItemContext);
  if (!menuAnchorEl) return null;

  return (
    <PlannerItemMenu
      itemAnchorEl={menuAnchorEl}
      selectedItemRef={selectedItemRef}
      closeActionMenu={closeActionMenu}
    />
  );
};

export default PlannerItemMenuWrapper;
